import React, { useEffect, useState } from "react";
import "./contactUs.scss";
import CommonBanner from "../../components/commonBanner/CommonBanner";
import { sun } from "../../source";
import CommonCta from "../../components/CommonCta/CommonCta";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Joi from "joi";
import config from "../../config/config";
import http from "../../helpers/http";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const ContactUs = () => {
  const [value, setValue] = useState();
  const baseUrl = config.api_url;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const schema = Joi.object({
    name: Joi.string().trim().required().messages({
      "string.empty": "Full Name is required",
      "any.required": "Full Name is required",
    }),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.empty": "Email ID is required",
        "string.email": "Please enter a valid email address",
        "any.required": "Email ID is required",
      }),
    phone: Joi.string().required().label("Mobile No.").messages({
      "string.empty": "Mobile No. is required",
      "string.base": "Please enter a valid mobile number",
    }),
    message: Joi.string().allow("").messages({
      "string.base": "Please enter a valid message",
    }),
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      phone: value || "",
    }));

    if (errors.phone) {
      setErrors((prev) => ({
        ...prev,
        phone: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    formData.phone = value || "";
    // Validate form data
    const { error } = schema.validate(formData, { abortEarly: false });

    if (error) {
      const validationErrors = {};
      error.details.forEach((detail) => {
        validationErrors[detail.path[0]] = detail.message;
      });
      setErrors(validationErrors);

      // Scroll to first error field
      const firstErrorField = http.getFirstError(validationErrors, "_error");
      console.log(firstErrorField);
      http.scroll(firstErrorField);
      return;
    }

    setIsSubmitting(true);
    setErrors({});
    setValue();
    try {
      const response = await http.post(`${baseUrl}/contact-us`, formData);

      if (response) {
        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });

        // Show thank you message
        setShowThankYou(true);

        // Hide thank you message after 5 seconds
        setTimeout(() => {
          setShowThankYou(false);
        }, 5000);
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ submit: "Failed to submit form. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Contact Us & Start Your Healing Journey Today - Pathways & Perspectives"
        metaDesc="Reach out to Pathways & Perspectives to book a session, ask a question, or learn more about our holistic coaching and healing services. We’re here to support you."
      />

      <section className="contact_sec1">
        <CommonBanner title="Contact Us" linkText1="Contact Us" />
      </section>

      <section className="contact_sec2" data-aos="fade-up">
        <img src={sun} alt="sun" className="sun_img" />
        <div className="my_container">
          <h1 className="section_heading100">get in touch</h1>
          <p className="section_desc22">
            Get in touch with us for interviews, collaborations, or any other
            inquiries — we’d love to hear from you.
          </p>
          <form className="form_wrapper" onSubmit={handleSubmit}>
            <div className="input_wrapper" id="name_error">
              <input
                type="text"
                name="name"
                placeholder="Full Name*"
                className="input_field"
                value={formData.name}
                onChange={handleInputChange}
              />
              <p className="error">{errors.name || ""}</p>
            </div>

            <div
              className="input_wrapper country_select_wrapper"
              id="phone_error"
            >
              {/* <input
                type="tel"
                placeholder="Mobile No."
                className="input_field"
              /> */}
              <PhoneInput
                className="input_select_field input_field"
                defaultCountry="IN"
                placeholder="Mobile No.*"
                value={value}
                onChange={setValue}
              />
              <p className="error">{errors.phone || ""}</p>
            </div>

            <div className="input_wrapper" id="email_error">
              <input
                type="text"
                name="email"
                placeholder="Email ID*"
                className="input_field"
                value={formData.email}
                onChange={handleInputChange}
              />
              <p className="error">{errors.email || ""}</p>
            </div>

            <div className="input_wrapper">
              <textarea
                className="input_field msg_field"
                name="message"
                placeholder="Type Your Text"
                value={formData.message}
                onChange={handleInputChange}
              ></textarea>
              <p className="error">{errors.message || ""}</p>
            </div>
            {errors.submit && <p className="error">{errors.submit}</p>}

            {/* <div className="input_wrapper">
              <input
                type="text"
                placeholder="Dummy Text*"
                className="input_field"
              />
              <p className="error"></p>
            </div> */}

            {/* <div className="input_wrapper">
              <select className="input_field select_field">
                <option value="Dummy">Dummy</option>
                <option value="Dummy">Dummy</option>
                <option value="Dummy">Dummy</option>
              </select>
              <p className="error"></p>
            </div> */}

            <CommonCta
              text={isSubmitting ? "SUBMITTING..." : "SUBMIT"}
              type="submit"
              disabled={isSubmitting}
            />
            {showThankYou && (
              <p
                style={{
                  color: "green",
                  marginTop: "10px",
                  fontSize: "14px",
                  textAlign: "center",
                }}
              >
                Thank you for your message! We'll get back to you soon.
              </p>
            )}
          </form>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
